module.exports = __webpack_public_path__ + "src/img/floatAngle.c094b811.svg";